import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link as GatsbyLink } from "gatsby";
import { useGlobalContext } from "context/global";
import { TOGGLE_SAVE_POPUP } from "utils/action-types";
import { subscriptionPageUrl } from "utils/constants";

const Link = ({ children, to, activeClassName, partiallyActive, ...other }) => {
	const { language } = useGlobalContext();
	const { isActive, draftChanges } = useSelector((state) => state.account.subscription);
	const dispatch = useDispatch();

	const lang = language === "default" ? "" : `/${language}`;
	const modifiedTo = to === "/" && isActive ? subscriptionPageUrl : to;
	const path = `${lang}${modifiedTo === "/" && language === "en" ? "" : modifiedTo}`;

	if (!to) return <>{children}</>;

	const internal = !(to.includes("http") || path.includes("/b2b") || path.includes("?"));

	const handleClick = (e) => {
		if (draftChanges.unsaved && !path.startsWith("#")) {
			e.preventDefault();
			dispatch({ type: TOGGLE_SAVE_POPUP, payload: { isVisible: true, redirectPath: path || to } });
		}
	};

	return internal ? (
		<GatsbyLink
			to={path}
			activeClassName={activeClassName}
			partiallyActive={partiallyActive}
			onClick={handleClick}
			{...other}
		>
			{children}
		</GatsbyLink>
	) : (
		<a
			href={to} {...other}
			onClick={handleClick}
		>
			{children}
		</a>
	);
};
export default Link;